import React, { useEffect, useState } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import ImageResize from 'quill-image-resize-module-react';

import 'react-quill/dist/quill.snow.css';

Quill.register('modules/imageResize', ImageResize);

interface IProps {
  onEditorChange: (value) => void;
  htmlValue: any;
}
const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'code',
  'code-block',
  'list',
  'bullet',
  'indent',
  'link',
  'color',
  'image',
  'background',
  'align',
  'size',
  'font',
   
];
const modules = {
  toolbar: [
    [{ font: [] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    [{ script: 'sub' }, { script: 'super' }],
    ['blockquote', 'code-block','code'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }, { align: [] }],
    ['link', 'image', 'video'],
    ['clean'],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
  imageResize: {
    parchment: Quill.import('parchment'),
    modules: ['Resize', 'DisplaySize'],
  },
};

const TextEditor = ({ onEditorChange, htmlValue }: IProps) => {
  const [value, setValue] = useState(htmlValue ?? '');

  const onChange = (content, delta, source, editor) => {
    setValue(content);
    onEditorChange(content);
    // console.log(editor.getHTML())
  };
  useEffect(() => {
    // console.log('htmlValue changed', htmlValue);
  }, [htmlValue]);
  return (
    <ReactQuill
      modules={modules}
      value={value ?? ''}
      formats={formats}
      style={{backgroundColor:"#ffffff"}}
      theme="snow"
      onChange={onChange}
      placeholder="Long Description goes here..."
    />
  );
};

export default TextEditor;
